import { Injectable } from '@angular/core';
import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getDatabase, Database, ref, get, set, update, push, remove, onValue, off, DataSnapshot } from 'firebase/database';
import { Observable } from 'rxjs';

const firebaseConfig = {
  apiKey:            'AIzaSyAdd5Xeb4WQCCgdY_kkJekFsHSB5AOAyv4',
  authDomain:        'gpaytest-ce1a4.firebaseapp.com',
  databaseURL:       'https://gpaytest-ce1a4-default-rtdb.firebaseio.com',
  projectId:         'gpaytest-ce1a4',
  storageBucket:     'gpaytest-ce1a4.firebasestorage.app',
  messagingSenderId: '458646130768',
  appId:             '1:458646130768:web:b047ff56a26a99ed66c155'
};

@Injectable({ providedIn: 'root' })
export class FirebaseService {
  readonly app:  FirebaseApp;
  readonly auth: Auth;
  readonly db:   Database;

  constructor() {
    this.app  = initializeApp(firebaseConfig);
    this.auth = getAuth(this.app);
    this.db   = getDatabase(this.app);
  }

  // ── Read once ──────────────────────────────────────────────────────────────
  async read<T>(path: string): Promise<T | null> {
    const snap = await get(ref(this.db, path));
    return snap.exists() ? (snap.val() as T) : null;
  }

  // ── Realtime listener → Observable ────────────────────────────────────────
  listen<T>(path: string): Observable<T | null> {
    return new Observable(observer => {
      const dbRef = ref(this.db, path);
      const handler = (snap: DataSnapshot) => observer.next(snap.exists() ? snap.val() as T : null);
      onValue(dbRef, handler, err => observer.error(err));
      return () => off(dbRef, 'value', handler);
    });
  }

  // ── Write / update / push / remove ────────────────────────────────────────
  async write(path: string, data: unknown): Promise<void> {
    return set(ref(this.db, path), data);
  }

  async patch(path: string, data: Record<string, unknown>): Promise<void> {
    return update(ref(this.db, path), data);
  }

  async pushNew(path: string, data: unknown): Promise<string> {
    const r = await push(ref(this.db, path), data);
    return r.key!;
  }

  async remove(path: string): Promise<void> {
    return remove(ref(this.db, path));
  }
}
